import Icon from '../components/Icon.vue'

Icon.register({
  'list-alt': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M464 480H48C21.5 480 0 458.5 0 432V80C0 53.5 21.5 32 48 32H464C490.5 32 512 53.5 512 80V432C512 458.5 490.5 480 464 480zM128 120C105.9 120 88 137.9 88 160S105.9 200 128 200 168 182.1 168 160 150.1 120 128 120zM128 216C105.9 216 88 233.9 88 256S105.9 296 128 296 168 278.1 168 256 150.1 216 128 216zM128 312C105.9 312 88 329.9 88 352S105.9 392 128 392 168 374.1 168 352 150.1 312 128 312zM416 176V144C416 137.4 410.6 132 404 132H204C197.4 132 192 137.4 192 144V176C192 182.6 197.4 188 204 188H404C410.6 188 416 182.6 416 176zM416 272V240C416 233.4 410.6 228 404 228H204C197.4 228 192 233.4 192 240V272C192 278.6 197.4 284 204 284H404C410.6 284 416 278.6 416 272zM416 368V336C416 329.4 410.6 324 404 324H204C197.4 324 192 329.4 192 336V368C192 374.6 197.4 380 204 380H404C410.6 380 416 374.6 416 368z'
      }
    ]
  }
})
